import { atomWithReset } from 'jotai/utils';

import { INITIAL_SERIE_FILTERS, type SerieFilters } from '../../types/serieFilters';

/**
 * Átomo com o estado dos filtros (server-side) da listagem de Séries.
 *
 * Deve ser consumido apenas via `useSerieFilters` (CLAUDE.md proíbe `useAtom`
 * direto em componentes). Resetável via `useResetAtom`.
 */
export const serieFiltersAtom = atomWithReset<SerieFilters>(INITIAL_SERIE_FILTERS);
